import React, { Component } from "react";
import { helpersFunctions } from "../../views/helpers";
import { Divider } from "primereact/divider";
import { OverlayPanel } from "primereact/overlaypanel";

import "../../views/Login/Help/help.scss";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <footer className="app-footer">
        <span>
          <a target="_blank" href="https://www.ajw-group.com/">
            AJW Group
          </a>{" "}
          &copy; {helpersFunctions.formatDate(new Date(), "YYYY")} ADS.
        </span>
        <OverlayPanel
          id="helpOverlay"
          ref={(el) => (this.op = el)}
          style={{ transform: "translate(-4px, -13px)" }}
        >
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              window.open("#/help");
            }}
          >
            Portal Customer Walkthrough{" "}
            <i
              id="chevron"
              className="pi pi-angle-double-right"
              style={{
                background: "none",
                color: "darkslategrey",
                boxShadow: "none",
                display: "inline-block",
                fontSize: "inherit",
                margin: "0",
              }}
            ></i>
          </div>
          {this.props.helpData && this.props.helpData.length > 0 && (
            <div>
              <Divider />
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  this.props.toggleHelpVisible(true);
                }}
              >
                Video Guide for {this.props.helpData[0].page} Page
              </div>
            </div>
          )}
        </OverlayPanel>
        <div
          id="helpLink"
          onClick={(e) => {
            this.op.toggle(e);
          }}
          style={{ position: "absolute", right: "20px" }}
        >
          <p style={{ color: "var(--color-info-teal)", margin: "0" }}>Help</p>
        </div>
      </footer>
    );
  }
}

export default Footer;
